<template>
  <div>
    <div class="hero">
      <div class="hero-body">
        <div class="container has-text-centered is-small">
          <h1 class="title">
            Exploration of French musical adaptations
          </h1>

          <p class="subtitle">
            Innovation unit on the valorization of BAnQ data in collaboration with École polytechnique de Montréal
          </p>
        </div>
      </div>
    </div>
    <hr class="is-marginless">
    <div class="section">
      <div class="container">
        <v-global />
      </div>
    </div>
    <hr class="is-marginless">
    <div class="section">
      <div class="container has-text-centered">
        <h2 class="title is-4">
          Explore an artist
        </h2>
        <div class="buttons">
          <router-link
            to="/artist/1923/chronology"
            class="button"
          >
            Jacques Brel
          </router-link>
          <router-link
            to="/artist/5596/chronology"
            class="button"
          >
            Claude François
          </router-link>
          <router-link
            to="/artist/9482/chronology"
            class="button"
          >
            Michel Louvain
          </router-link>
          <router-link
            to="/artist/1895/chronology"
            class="button"
          >
            Georges Brassens
          </router-link>
          <router-link
            to="/artist/4799/chronology"
            class="button"
          >
            Bob Dylan
          </router-link>
          <router-link
            to="/artist/5788/chronology"
            class="button"
          >
            Serge Gainsbourg
          </router-link>
          <router-link
            to="/artist/3863/chronology"
            class="button"
          >
            Joe Dassin
          </router-link>
          <router-link
            to="/artist/2064/chronology"
            class="button"
          >
            Gilles Brown
          </router-link>
          <router-link
            to="/artist/4392/chronology"
            class="button"
          >
            Céline Dion
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalVue from "../components/global/Global.vue";
export default {
	components: {
		"v-global": GlobalVue
	}
};
</script>
